var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg34 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "34")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M59.66,34.23c3.88,0,7.69,0,11.5,0,4.45,0,7.77,2.47,8.73,6.43a9.12,9.12,0,0,1-1.49,7.67,2.05,2.05,0,0,0-.35,2A8.93,8.93,0,0,1,77,57.87a2.53,2.53,0,0,0-.21,1.91,9.44,9.44,0,0,1-2,7.39,2.4,2.4,0,0,0-.54,1.67c0,6.09-3.25,9.61-9.28,10.21A52.52,52.52,0,0,1,41,75.56a35.28,35.28,0,0,0-7.39-2.1A2.8,2.8,0,0,1,31,70.34Q31,56.69,31,43c0-1.93.67-2.77,2.51-3.19A5.23,5.23,0,0,0,36,38.23,75.88,75.88,0,0,0,42.08,31a22.08,22.08,0,0,1,2.46-3c2.69-2.4,3.58-5.58,4.17-8.93a15.55,15.55,0,0,1,1.16-4c1.51-3.21,2.82-3.87,6.29-3.15,4.51.93,6.82,3.92,7.09,8.89a18.66,18.66,0,0,1-2.4,10.48A8.06,8.06,0,0,0,59.66,34.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.17,43.06c0-2.17-1-3.21-3.19-3.23q-5.9,0-11.79,0c-2.32,0-3.26.94-3.27,3.26,0,4.49,0,9,0,13.48s0,9.21,0,13.81c0,2.14,1,3.17,3.21,3.18q5.9,0,11.79,0c2.11,0,3.23-1.12,3.24-3.21Q28.2,56.71,28.17,43.06ZM18.25,68a2.84,2.84,0,0,1,0-5.68,2.84,2.84,0,1,1,0,5.68Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg34, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/34.39da1a5a.svg";
export { ForwardRef as ReactComponent };